import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import CustomSlider from '../Slider/Slider';
import kota5 from "../Asserts/kota5.png";
import kota3 from "../Asserts/kota3.png";
import aboutmain from "../bank/aboutmain.png"
import corevalue from "../Asserts/corevalues.jpg"

const slideInFromRight = {
  initial: { x: '+100vw', opacity: 0 },
  animate: { x: 0, opacity: 1 },
  transition: { type: 'spring', stiffness: 80, damping: 15 }
};

const slideInFromLeft = {
  initial: { x: '-100vw', opacity: 0 },
  animate: { x: 0, opacity: 1 },
  transition: { type: 'spring', stiffness: 80, damping: 15 }
};

function About_us() {
  return (
    <div className='bg-white min-h-screen flex flex-col gap-8 '>
      <Helmet>
        <title>About Us</title>
        <meta name='description' content='A Vision of My 30-Year World' />
      </Helmet>

      {/* Heading Section */}
      <div className='w-full bg-[#FF6F00]'>
        <ul className='w-full bg-[#FF6F00] md:h-40 h-20 flex justify-center items-center text-center '>
          <motion.div 
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className='text-center'
          >
            <h1 className='md:text-6xl text-2xl text-white font-bold'>OUR EXCELLENCE</h1>
          </motion.div>
        </ul>
      </div>

      {/* First Section */}
      <div className="flex flex-col gap-16  ">
  {/* Who We Are Section */}
  <div className="flex flex-col sm:flex-col-reverse md:flex-row-reverse items-center gap-8 justify-center px-10">
    <motion.div {...slideInFromRight} className="flex-1 flex justify-center">
      <img
        src={kota3}
        alt="Success Image"
        className="w-full max-w-[600px]  rounded-full"
      />
    </motion.div>
    <motion.div {...slideInFromLeft} className="flex-1 flex flex-col md:text-left md:ml-12">
      <h3 className="md:text-4xl text-2xl text-[#FF6F00] font-bold mb-3">Who We Are?</h3>
      <u className="bg-[#F4c430] h-1 md:w-52 w-32"></u>
      <p className="text-base leading-loose md:mt-7 mt-3 font-medium text-gray-700">
      Money shapes countless decisions in people’s lives, and every sound financial choice begins with expert guidance. Financial advisors help clients navigate their monetary journey with confidence.

A strong mission and vision statement is essential for financial advisors to communicate their unique value. It sets the foundation for a successful practice and helps clients understand what makes their services different and valuable.

Want to see how top financial advisors position their practices? Let’s explore powerful mission and vision statements that inspire trust and success.  </p>
    </motion.div>
  </div>
  {/* Our Vision Section */}
  <div className="grid md:grid-cols-2 items-center gap-8">
    <motion.div {...slideInFromLeft} className="flex justify-center">
      <img
        src={kota5}
        alt="Process Image"
        className="w-full max-w-[500px] "
      />
    </motion.div>
    <motion.div {...slideInFromRight} className="flex flex-col md:text-left text-left md:mr-12 px-10">
      <h3 className="md:text-4xl text-2xl text-[#FF6F00] font-bold mb-2">Our Vision</h3>
      <u className="bg-[#F4c430] h-1 md:w-44 w-28"></u>
      <p className="text-base leading-loose md:mt-7 mt-4 font-medium text-gray-700">
      Our mission is to be the leading financial advisory firm, helping clients achieve their financial goals with confidence. We provide high-quality risk and wealth management solutions tailored to individual needs.

With a team of trusted and professional financial consultants, we are committed to delivering expert guidance and personalized strategies. Our goal is to build long-term relationships based on integrity, reliability, and excellence.

By prioritizing our clients' financial well-being, we empower them to make informed decisions and secure a prosperous future.      </p>
    </motion.div>
  </div>

  {/* Our Mission Section */}
  <div className="flex flex-col sm:flex-col-reverse md:flex-row-reverse items-center gap-8 justify-center px-10">
    <motion.div {...slideInFromRight} className="flex-1 flex justify-center">
      <img
        src={corevalue}
        alt="Success Image"
        className="w-full max-w-[400px] rounded-full"
      />
    </motion.div>
    <motion.div {...slideInFromLeft} className="flex-1 flex flex-col md:text-left md:ml-24">
      <h3 className="md:text-4xl text-2xl text-[#FF6F00] font-bold mb-3">Our Mission</h3>
      <u className="bg-[#F4c430] h-1 md:w-52 w-32"></u>
      <p className="text-base leading-loose md:mt-7 mt-3 font-medium text-gray-700">
      Our goal is to build lasting relationships with both individual and corporate clients by offering personalized financial solutions. We specialize in risk and wealth management strategies tailored to evolving needs.

By understanding each client’s unique financial journey, we provide expert guidance and customized plans for long-term success. Our commitment to trust, reliability, and excellence ensures a strong foundation for financial growth and security.      </p>
    </motion.div>
  </div>

  {/* Core Values Section */}
  <div className="grid md:grid-cols-2 items-center gap-8">
    <motion.div {...slideInFromLeft} className="flex justify-center">
      <img
        src={aboutmain}
        alt="Process Image"
        className="w-full max-w-[500px] rounded-full"
      />
    </motion.div>
    <motion.div {...slideInFromRight} className="flex flex-col md:text-left md:mr-12 px-10">
      <h3 className="md:text-4xl text-2xl text-[#FF6F00] font-bold mb-2">Core Values</h3>
      <u className="bg-[#F4c430] h-1 md:w-44 w-28"></u>
      <p className="text-base leading-loose md:mt-7 mt-4 font-medium text-gray-700 ">
      Our vision is to be the leading financial advisory firm, dedicated to helping clients achieve their financial goals. We provide high-quality risk and wealth management solutions tailored to their needs.

With a team of trusted and professional financial consultants, we strive to deliver expert guidance and personalized strategies. Our commitment to excellence ensures long-term financial security and success for our clients.      </p>
    </motion.div>
  </div>
</div>

      {/* Core Values Details */}
      <div className="p-6 ">
        <h4 className="md:text-4xl text-2xl font-bold mb-4 text-center text-[#FF6F00] mt-20 ">Our Business is Guided by Three Core Values</h4>
        <p className="mb-8 text-gray-700 text-center">
          We always act in the best interests of our customers with fair dealing as the basis of our business.
        </p>
      
          {/* Integrity */}
          <div className="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0 p-8 rounded-lg">
  {/* Integrity */}
  <div className="flex flex-col space-y-4 bg-white p-6 rounded-lg shadow-md border-2 border-[#FF6F00] flex-1 min-h-[300px]">
    <p className="font-semibold text-lg text-center text-gray-800">INTEGRITY</p>
    <div className="h-[2px] bg-gray-200"></div>
    <ol className="pl-6 text-gray-700 space-y-2 list-disc list-inside">
      <li>Maintain highest standards of integrity</li>
      <li>Have fair dealing as the basis of our business to safeguard customer interest</li>
      <li>Provide quality holistic financial planning</li>
    </ol>
  </div>

  {/* Initiative */}
  <div className="flex flex-col space-y-4 bg-white p-6 rounded-lg shadow-md border-2 border-[#FF6F00] flex-1 min-h-[300px]">
    <p className="font-semibold text-lg text-gray-800 text-center">INITIATIVE</p>
    <div className="h-[2px] bg-gray-200"></div>
    <ol className="pl-6 text-gray-700 space-y-2 list-disc list-inside">
      <li>Strive for excellence in everything we do</li>
      <li>Be customer-focused — always</li>
      <li>Be proactive in our approach</li>
      <li>Improve, innovate and generate new ideas</li>
    </ol>
  </div>

  {/* Involvement */}
  <div className="flex flex-col space-y-4 bg-white p-6 rounded-lg shadow-md border-2 border-[#FF6F00] flex-1 min-h-[300px]">
    <p className="font-semibold text-lg text-gray-800 text-center">INVOLVEMENT</p>
    <div className="h-[2px] bg-gray-200"></div>
    <ol className="pl-6 text-gray-700 space-y-2 list-disc list-inside">
      <li>Foster strong sense of belonging for all stakeholders</li>
      <li>Provide conducive environment to promote growth and development</li>
      <li>Adopt a team approach governed by respect and courtesy</li>
      <li>Be a responsible member of our community</li>
    </ol>
  </div>
</div>
      </div>

      {/* Final Section */}
      <div className='   justify-center flex-col items-center gap-4 hidden md:flex'>
        <p className='font-bold md:text-3xl text-2xl text-[#FF6F00] text-center'>
          Highest Standards. <br className='md:hidden' /> Happiest Partners
        </p>
        <u className="bg-[#F4c430] h-1 md:w-52 w-32"></u>
      </div>

      <div className='mt-10 mb-20'>
      <CustomSlider />
     </div>
    </div>
  );
}

export default About_us;
